<template>
	<v-container>
			<v-col>
				<h1>Risk Description : <span style="font-size: 0.8em;">{{ this.$store.getters.selectedTitle }}</span></h1>
				<br/>
			</v-col>
			<v-data-table
				theme="--light"
				:headers="headers"
				:items="connections"
				:search="search"
				:items-per-page="20"
				class="light table"
				hide-default-footer
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 20],
				}"
			>
				<template v-slot:header="{ headers }">
					<thead>
						<tr>
							<th
								v-for="header in headers"
								:key="header.text"
								class="custom-header"
							>
								{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.Risk="{ item }">
					<td style="text-align: center;"><span>{{ item.Risk }}</span></td>
				</template>
				<template v-slot:item.RiskDescription="{ item }">
					<td style="text-align: justify; padding: 5px 0px;"><span>{{ item.RiskDescription }}</span></td>
				</template>
				<template v-slot:item.TypesOfRisk="{ item }">
					<td style="text-align: center;"><span style="padding-left: 	15px;">{{ item.TypesOfRisk }}</span></td>
				</template>
				<template v-slot:item.Consequence="{ item }">
					<td style="text-align: center;">
						<span>{{ item.Consequence }},{{ item.Probability }}</span>
					</td>
				</template>
			</v-data-table>
	</v-container>
</template>

<script>
import { riskAPI } from "../../api/csr/risk"
import LoadingState from "../../consts/LoadingState"
import { mapGetters } from "vuex"

export default {
	data() {
		return {
			ID: null,
			clientID: null,
			dialogDelete: false,
			dialogHistory: false,
			connections: [],
			avgScore: [],
			search: "",
			headers: [
				{
					text: "No",
					align: "start",
					value: "no",
					sortable: false,
					width:"5%",
				},
				{
					text: "Risk",
					align: "center",
					value: "Risk",
					sortable: false,
					width:"15%",
				},
				{
					text: "Risk Description",
					align: "center",
					value: "RiskDescription",
					sortable: false,
					width:"50%",
				},
				{
					text: "Risk Type",
					align: "center",
					value: "TypesOfRisk",
					sortable: false,
				},
				{
					text: "Cons,Prob",
					align: "center",
					value: "Consequence",
					sortable: false,
				},

			],
			statusHeaders: [
				{
					text: "Creator",
					value: "Creator",
					sortable: false,
					class: "secondary--text",
				},
				{
					text: "Status",
					value: "Status",
					sortable: false,
					class: "secondary--text",
				},
				{
					text: "Timestamp",
					value: "Timestamp",
					sortable: false,
					class: "secondary--text",
				},
				{
					text: "Comment",
					value: "Comment",
					sortable: false,
					class: "secondary--text",
				},
				{
					text: "Consequence",
					value: "Consequence",
					sortable: false,
					class: "secondary--text",
				},
				{
					text: "Probability",
					value: "Probability",
					sortable: false,
					class: "secondary--text",
				},
			],

			tableData: [],
		}
	},
	computed: {
		...mapGetters([
			"selectedId",
			"selectedYear",
			"selectedTitle",
			"selectedDescription",
			"selectedStatus",
		]),
		isActionAllowed() {
			return this.selectedStatus === "Active"
		},
	},
	watch: {
		selectedId(newVal) {
			console.log("Selected ID changed Risk Description:", newVal)
			this.loadItems(newVal)
		},
	},
	mounted() {
		this.loadItems(this.selectedId)
	},
	methods: {
		loadItems(id) {
			this.connections = []
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			riskAPI
				.getAll(id)
				.then((data) => {
					let editbutton = ""
					let no = 0

					for (let entry of data[0]) {
						this.connections.push({
							no: ++no,
							ID: entry.ID,
							Risk: entry.Risk,
							RiskDescription: entry.RiskDescription,
							TypesOfRisk: entry.TypesOfRisk,
							RiskOwner: entry.RiskOwner,
							Created: entry.Created.split("T")[0],
							Creator: entry.Creator,
							Consequence:
								entry.UpdatedConsequence != null
									? entry.UpdatedConsequence
									: entry.Consequence,
							Probability:
								entry.UpdatedProbability != null
									? entry.UpdatedProbability
									: entry.Probability,
							editbutton: editbutton,
							FirstConsequence: entry.Consequence,
							FirstProbability: entry.Probability,
							UpdatedConsequence: entry.UpdatedConsequence,
							UpdatedProbability: entry.UpdatedProbability,
							UpdatedDate:
								entry.UpdatedDate != null
									? entry.UpdatedDate.split("T")[0]
									: entry.UpdatedDate,
							CommentforUpdate: entry.CommentforUpdate,
						})
					}
					// Can't make a check inside for loop (eslint), have to remove it outside. Not a good fix.
					/*					this.connections = this.connections.filter(function (obj) {
						return obj.clientID !== 1 // clientID 1 is the user (client accessing the portal).
					}) */
					// Used by old method of showing sustainability
					//this.averageScore() // Calculating average score of all suppliers
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.$emit("row-count", this.connections.length)
					this.$emit("ready")
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
					this.$emit("row-count", 0)
					this.$emit("ready")
				})
		},
		calculateStatus(probability, consequence) {
			if (
				(probability <= 5 && consequence <= 20) ||
				(probability <= 10 && consequence <= 10) ||
				(probability <= 20 && consequence <= 5)
			) {
				return "Low"
			} else if (
				(probability > 20 && consequence > 10) ||
				(probability > 15 && consequence > 15) ||
				(probability > 10 && consequence > 20)
			) {
				return "High"
			} else {
				return "Moderate"
			}
		},
		deleteItem(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		historyItem(item) {
			this.itemToHistory = item
			this.dialogHistory = !this.dialogHistory

			// Start with the first row
			let newData = [
				{
					Creator: item.Creator,
					Status: this.calculateStatus(
						item.FirstProbability,
						item.FirstConsequence
					),
					Timestamp: item.Created,
					Comment: item.RiskDescription,
					Consequence: item.FirstConsequence,
					Probability: item.FirstProbability,
				},
			]

			// Add the second row if item.UpdatedConsequence is not null
			if (item.UpdatedConsequence != null) {
				newData.push({
					Creator: item.Creator,
					Status: this.calculateStatus(
						item.UpdatedProbability,
						item.UpdatedConsequence
					),
					Timestamp: item.UpdatedDate,
					Comment: item.CommentforUpdate,
					Consequence: item.UpdatedConsequence,
					Probability: item.UpdatedProbability,
				})
			}

			// Update tableData
			this.$set(this, "tableData", newData)
		},

		updateItem(item) {
			this.$router.push({
				path: "/csr/riskmatrix/update",
				query: {
					itemId: item.ID,
				},
			})
		},
		editItem(item) {
			this.$router.push({
				path: "/csr/riskmatrix/edit",
				query: {
					itemId: item.ID,
				},
			})
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.connections.indexOf(this.itemToDelete)
			this.$store.commit("setSelectedNewstate", true)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			riskAPI
				.deleteRisk(this.itemToDelete.ID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Risk item was successfully removed from the list.",
						{ root: true }
					)
					
					this.connections.splice(index, 1)
					window.location.href = "/csr/riskmatrix/riskpage"
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			
		},
	},
}
</script>

<style>
.v-progress-circular {
	margin: 0rem;
}

.addnewbutton {
	display: flex;
	justify-content: flex-end;
}

.custom-header {
	font-size: 100px;
}

.v-data-table .v-data-table-header tr th {
	font-size: 15px !important;
	color: #217b7f !important;
}

.buttonfeather {
	display: flex;
}

.small_cell {
	width: 20px !important;
	padding-right: 0px;
}
</style>
